var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-box-container", attrs: { id: _vm.contract.id } },
    [
      [
        _c(
          "div",
          {
            staticClass: "d-flex list-box-header col-12 pointer",
            on: {
              mouseup: function($event) {
                if ("button" in $event && $event.button !== 1) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                _vm.viewMiddle($event, _vm.contract.id)
              },
              click: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "left", 37, $event.key, [
                    "Left",
                    "ArrowLeft"
                  ])
                ) {
                  return null
                }
                if ("button" in $event && $event.button !== 0) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                _vm.view($event, _vm.contract.id)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "pl-0 list-box-header-left col-lg-7 col-7 col-md-6 pr-3"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "pl-0 d-flex align-items-center col-5 col-md-6"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _c("span", { staticClass: "ref-id" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.contract.name) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pl-0 d-flex align-items-center col-7" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.contract.companies.length > 5
                                  ? _vm.companies(
                                      _vm.contract.companies.slice(0, 5)
                                    ) +
                                    " and " +
                                    (_vm.contract.companies.length - 5) +
                                    " more"
                                  : _vm.companies(_vm.contract.companies)
                              ) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-box-header-right col-lg-5 col-5 pl-4" },
              [
                _c("div", { staticClass: "d-flex align-items-center col-9" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.contract.created_at) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center col-3" }, [
                  _c("i", {
                    staticClass: "fa fa-circle pr-2",
                    class: [_vm.contract.active === 1 ? "active" : "inactive"]
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.contract.active === 1 ? "Active" : "Inactive"
                      ) +
                      "\n        "
                  )
                ])
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-032eb4ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-032eb4ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractsBlock.vue
// module id = null
// module chunks = 